import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ToggleSwitch from './ToggleSwitch';
import './FilterModal.css';

const PetsModal = ({ show, onHide, value, onUpdate }) => {
  const [selectedValue, setSelectedValue] = useState(value || '');
  const [showOthers, setShowOthers] = useState(false);

  const petsOptions = [
    'Dog',
    'Cat',
    'Fish',
    'Turtle',
    'Want a pet',
    'No',
    'Don\'t have, but love them',
    'Allergic to pets'
  ];

  const handleOptionSelect = (option) => {
    setSelectedValue(option);
  };

  const handleApply = () => {
    onUpdate(selectedValue);
    onHide();
  };

  const handleClear = () => {
    setSelectedValue('');
    onUpdate('');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="filter-modal">
      <Modal.Header closeButton>
        <Modal.Title>Do they have any pets?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="filter-options">
          {petsOptions.map((option) => (
            <div
              key={option}
              className={`filter-option ${selectedValue === option ? 'selected' : ''}`}
              onClick={() => handleOptionSelect(option)}
            >
              <input
                type="radio"
                id={`pets-${option}`}
                name="pets"
                value={option}
                checked={selectedValue === option}
                onChange={() => handleOptionSelect(option)}
              />
              <label htmlFor={`pets-${option}`}>{option}</label>
            </div>
          ))}
        </div>
        
        {/* Toggle Switch */}
        <ToggleSwitch 
          checked={showOthers} 
          onChange={setShowOthers}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClear} className="filter-modal-btn secondary">
          Clear
        </Button>
        <Button variant="primary" onClick={handleApply} className="filter-modal-btn primary">
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PetsModal;
